import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import { PaymentComponent } from "./PaymentComponent";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
export const stripePromise = loadStripe(
  `pk_live_51PsELAP0w6EimAlYLm7RjSNXvv22fzKMHQwediVlIYcn17oCdnx3UItHmZmKITjZjQ1WkhhpDL5Hq7kY2K655TzU00Syfy258y`
);
export const Payment = ({ isTopUpPlan, isAdditionalAssistant }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [plan, setPlan] = useState({});
  const [options, setOptions] = useState({
    mode: "payment",
    amount: 500,
    currency: "usd",
    // passing the client secret obtained from the server
    // clientSecret: secret,
  });
  const isFromDashBoard =
    location.pathname.includes("subscription") ||
    location.pathname.includes("topup") || 
    location.pathname.includes("additional-assistant-payment");

  const handleContinue = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    setPlan(location?.state?.plan);
    if (location.state) {
      setOptions({
        mode: "payment",
        amount: location.state?.price ? location.state?.price : 10,
        currency: "usd",
      });
    }
  }, [location]);

  return (
    <section className="layoutContainer layoutContainer--full">
      <div className="layoutGrid">
        <div className="page page--loginOtp">
          {isFromDashBoard ? null : (
            <div className="page__head">
              <div className="page__head__logo">
                <img src={logo} alt="Logo | Vox App" />
              </div>
              <div className="page__head__actions">
                <button className="backBtn" onClick={handleContinue}>
                  Skip
                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.5 16L8.5 9L1.5 2"
                      stroke="#8b58f1"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}

          <Elements stripe={stripePromise} options={options}>
            <ElementsConsumer>
              {({ stripe, elements }) => (
                <PaymentComponent
                  elements={elements}
                  stripe={stripe}
                  plan={plan}
                  isTopUpPlan={isTopUpPlan}
                  isFromDashBoard={isFromDashBoard}
                  isAdditionalAssistant={isAdditionalAssistant}
                />
              )}
            </ElementsConsumer>
          </Elements>
        </div>
      </div>
    </section>
  );
};
